import { MutationTree } from "vuex";
import { CallingState, initCallingModuleState, VideoCallingQuality } from "./state";
import { defineVuexName, MODULES } from "../utils";
import { MediaUserPublishStatus, updateUserIds } from "./utils";
import { MediaDeviceError } from "@/agora/utils";

export enum CallingUserStatus {
  LEFT,
  JOINED,
}

const mutations: MutationTree<CallingState> = {
  //setCallingUserIds
  [defineVuexName(MODULES.CALLING.COMMITS.SET_CALLING_USER_IDS)](state: CallingState, { id, status }: { id: string; status: CallingUserStatus }) {
    const index = state.callingUserIds.findIndex((remoteId) => remoteId === id);
    if (status === CallingUserStatus.LEFT) {
      return index > -1 && state.callingUserIds.splice(index, 1);
    }
    index === -1 && state.callingUserIds.push(id);
  },
  [defineVuexName(MODULES.CALLING.COMMITS.SET_VIDEO_USER_IDS)](state: CallingState, { id, status }: { id: string; status: MediaUserPublishStatus }) {
    updateUserIds(state.videoUserIds, { id, status });
  },
  [defineVuexName(MODULES.CALLING.COMMITS.SET_AUDIO_USER_IDS)](state: CallingState, { id, status }: { id: string; status: MediaUserPublishStatus }) {
    updateUserIds(state.audioUserIds, { id, status });
  },
  [defineVuexName(MODULES.CALLING.COMMITS.SET_IS_JOINED_SESSION)](s: CallingState, joined: boolean) {
    s.isJoinedSession = joined;
  },
  //resetState
  [defineVuexName(MODULES.CALLING.COMMITS.RESET_STATE)](s: CallingState) {
    if (s.postLocalUserReconnectedIntervalId) {
      clearInterval(s.postLocalUserReconnectedIntervalId);
    }
    Object.assign(s, initCallingModuleState());
  },
  //setEnabledAgoraNoiseCancelling
  [defineVuexName(MODULES.CALLING.COMMITS.SET_ENABLED_AGORA_NOISE_CANCELLING)](s: CallingState, enabled: boolean) {
    s.enabledAgoraNoiseCancelling = enabled;
  },
  //setPostLocalUserReconnectedIntervalId
  [defineVuexName(MODULES.CALLING.COMMITS.SET_POSTLOCAL_USER_RECONNECTED_INTERVAL_ID)](s: CallingState, intervalId: number) {
    s.postLocalUserReconnectedIntervalId = intervalId;
  },
  //setCameraError
  [defineVuexName(MODULES.CALLING.COMMITS.SET_CAMERA_ERROR)](s: CallingState, error: MediaDeviceError) {
    s.cameraError = error;
  },
  //setMicrophoneError
  [defineVuexName(MODULES.CALLING.COMMITS.SET_MICROPHONE_ERROR)](s: CallingState, error: MediaDeviceError) {
    s.microphoneError = error;
  },
  [defineVuexName(MODULES.CALLING.COMMITS.SET_VIDEO_CALLING_QUALITY)](s: CallingState, quality: string) {
    if (Object.values(VideoCallingQuality).includes(quality as VideoCallingQuality)) {
      s.videoCallingQuality = quality as VideoCallingQuality;
    }
  },
  [defineVuexName(MODULES.CALLING.COMMITS.RESET_REMOTE_USERS_STATE)](s: CallingState) {
    s.callingUserIds = [];
    s.videoUserIds = [];
    s.audioUserIds = [];
  },
};

export default mutations;
